import { matchPath, useLocation, useParams } from 'react-router-dom';

export function useRouteMatch(patterns: readonly string[]) {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];

    const possibleMatch = matchPath(pattern, pathname);

    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }
  return null;
}

/**
 * Returns the root path of the application (either /intern or /extern).
 * This is used for sidebar links to ensure they always resolve from the app root.
 */
export function useAppRoot() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/extern')) return '/extern';
  return '/intern';
}

/**
 * Returns the base path of the current route, excluding its own splat (*) segment.
 * This is useful for resolving relative paths in a way that is consistent between
 * React Router v6 and v7.
 */
export function useBasePath() {
  const { pathname } = useLocation();
  const params = useParams();
  const splat = params['*'];

  if (splat) {
    const splatIndex = pathname.lastIndexOf(splat);
    if (splatIndex !== -1) {
      return pathname.substring(0, splatIndex).replace(/\/$/, '');
    }
  }

  return pathname.replace(/\/$/, '');
}
